module.exports = __webpack_public_path__ + "img/couples-072.97a6f0e8.jpg";